import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaWhatsapp } from 'react-icons/fa';

// Define the social links data outside the component
const socialLinks = [
  { 
    name: 'WhatsApp', 
    icon: FaWhatsapp, 
    url: 'https://wa.me/YOUR_PHONE_NUMBER_HERE', 
    color: { horizontal: 'hover:text-green-600', sidebar: 'bg-green-600 hover:bg-green-700' }
  },
  { 
    name: 'Instagram', 
    icon: FaInstagram, 
    url: 'https://www.instagram.com/your-salon-handle', 
    color: { horizontal: 'hover:text-pink-600', sidebar: 'bg-pink-600 hover:bg-pink-700' }
  },
  { 
    name: 'Facebook', 
    icon: FaFacebookF, 
    url: 'https://www.facebook.com/your-salon-page', 
    color: { horizontal: 'hover:text-blue-600', sidebar: 'bg-blue-600 hover:bg-blue-700' }
  },
  { 
    name: 'YouTube', 
    icon: FaYoutube, 
    url: 'https://www.youtube.com/@your-channel', 
    color: { horizontal: 'hover:text-red-600', sidebar: 'bg-red-600 hover:bg-red-700' }
  },
  { 
    name: 'Twitter', 
    icon: FaTwitter, 
    url: 'https://twitter.com/your-salon-handle', 
    color: { horizontal: 'hover:text-sky-400', sidebar: 'bg-sky-400 hover:bg-sky-500' }
  },
];
// src/components/SocialLinks.jsx

// ... socialLinks array setup remains the same ...

const SocialLinks = ({ position = 'horizontal' }) => {
  
    // 1. Define the wrapper classes (no change needed here)
    const wrapperClasses = position === 'sidebar'
      ? 'fixed left-1 top-1/2 transform -translate-y-1/2 z-50 p-2 shadow-xl rounded-r-lg bg-white/50 hidden md:block'
      : 'flex justify-center space-x-6 pt-8'; 
      
    const containerClasses = position === 'sidebar'
      ? 'flex flex-col space-y-3'
      : 'flex space-x-6'; 
      
    const iconSizeClass = position === 'sidebar' ? 'text-xl' : 'text-3xl';
  
    return (
      <div className={wrapperClasses}>
        <div className={containerClasses}>
          {socialLinks.map((link) => (
            // 2. CONSTRUCT CLASSNAME INSIDE THE LOOP
            <a 
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              
              // --- MODIFIED CLASSNAME LOGIC HERE ---
              className={
                position === 'sidebar'
                  ? `w-10 h-10 flex items-center justify-center text-white rounded-md transition duration-300 ${link.color.sidebar}`
                  : `text-gray-500 transition-colors duration-300 ${link.color.horizontal}`
              }
              // ------------------------------------
              
              aria-label={`Connect on ${link.name}`}
            >
              <link.icon className={iconSizeClass} />
            </a>
          ))}
        </div>
      </div>
    );
  };
  
  export default SocialLinks;